import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form/immutable';

import Tabs from '../../components/tabs';
import RadioInput from '../../components/form-input-radio';
import { loadSettings, updateSettings } from './actions';
import { clearStatusBar } from '../../containers/status-bar/actions';
import StatusBar from '../../containers/status-bar';
import ComingSoonText from '../../components/coming-soon-text';
import { ALL, MILESTONES, NONE, INSTANTLY, HOURLY, DAILY } from '../../utils/static-configuration';

class UserSettings extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  componentDidMount() {
    this.props.onLoadSettings();
  }

  componentWillUnmount() {
    this.props.onClearStatusBar();
  }

  handleUpdate = formData => {
    const data = {
      emailType: formData.get('type'),
      emailFrequency: formData.get('frequency'),
    };
    this.props.onUpdateSettings(data);
  };

  handleTabChange = tab => event => {
    if (event) event.preventDefault();
    if (tab === 'PROFILE') {
      this.context.router.push('/profile');
    }
  };

  render() {
    const {
      settings,
      handleSubmit,
      loadingSettings,
      loadSettingsError,
      updateSettingsLoading,
    } = this.props;

    return (
      <div className="page profile">
        <Tabs
          headerStyle="padded-content white border-bottom"
          tabsStyle={'tabs'}
          data={['PROFILE', 'NOTIFICATIONS_SETTINGS']}
          panesTitles={{ PROFILE: 'Profile', NOTIFICATIONS_SETTINGS: 'Notification preferences' }}
          active={'NOTIFICATIONS_SETTINGS'}
          onClick={this.handleTabChange}
        />

        <div className="page-content">
          <div className="grid">

            <StatusBar />

            { loadingSettings &&
              <div className="discussion-preloader">
                <img src="/icons/dyzio-icon.svg" alt="Loading..." />
              </div>
            }
            { !loadingSettings && loadSettingsError &&
              <p>Error: {loadSettingsError}</p>
            }
            { !loadingSettings && !loadSettingsError &&
              <form onSubmit={handleSubmit(this.handleUpdate.bind(this))}>

                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <h3 className="label">Notification Preferences</h3>
                </div>

                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <h4>E-mail</h4>
                  <span className="hint">
                    Select the type of notifications you would like to receive
                  </span>
                  <div className="profile-form-wrapper">
                    <div className="profile-form-row">
                      <Field
                        id="all"
                        type="radio"
                        component={RadioInput}
                        name="type"
                        value={ALL}
                        label="All Messages"
                      />
                    </div>
                    <div className="profile-form-row">
                      <Field
                        id="milestones"
                        type="radio"
                        component={RadioInput}
                        disabled
                        name="type"
                        value={MILESTONES}
                        label="Milestones only  (brief, contract and deliverables)"
                      />
                      <ComingSoonText />
                    </div>
                    <div className="profile-form-row">
                      <Field
                        id="none"
                        type="radio"
                        component={RadioInput}
                        name="type"
                        value={NONE}
                        label="None"
                      />
                    </div>
                  </div>
                </div>

                <div className="grid-6-6 grid-sm-6-6 grid-md-6-6 grid-lg-6-6 grid-xl-6-6">
                  <h4>Email Frequency</h4>
                  <span className="hint">
                    How often would you like to receive emails?
                  </span>
                  <div className="profile-form-wrapper">
                    <div className="profile-form-row">
                      <Field
                        id="instantly"
                        type="radio"
                        component={RadioInput}
                        name="frequency"
                        value={INSTANTLY}
                        label="Instantly"
                      />
                    </div>
                    <div className="profile-form-row">
                      <Field
                        id="hourly"
                        type="radio"
                        component={RadioInput}
                        disabled
                        name="frequency"
                        value={HOURLY}
                        label="Hourly"
                      />
                      <ComingSoonText />
                    </div>
                    <div className="profile-form-row">
                      <Field
                        id="daily"
                        type="radio"
                        component={RadioInput}
                        disabled
                        name="frequency"
                        value={DAILY}
                        label="Daily"
                      />
                      <ComingSoonText />
                    </div>
                  </div>
                </div>

                <div className="grid-3-6 grid-sm-3-6 grid-md-3-6 grid-lg-3-6 grid-xl-3-6">
                  { !updateSettingsLoading &&
                    <button className="medium rose">Save</button>
                  }
                  { updateSettingsLoading &&
                    <button className="medium rose" disabled>
                      <ul className="dots">
                        <li id="dot1" />
                        <li />
                        <li id="dot2" />
                        <li />
                        <li id="dot3" />
                      </ul>
                    </button>
                  }
                </div>
              </form>
            }
          </div>
        </div>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};
}

const mapStateToProps = state => ({
  settings: state.userSettings.get('settings'),
  loadingSettings: state.userSettings.get('loadingSettings'),
  loadSettingsError: state.userSettings.get('loadSettingsError'),
  updateSettingsLoading: state.userSettings.get('updateSettingsLoading'),
  updateSettingsError: state.userSettings.get('updateSettingsError'),
  initialValues: {
    type: state.userSettings.getIn(['settings', 'emailType']),
    frequency: state.userSettings.getIn(['settings', 'emailFrequency']),
  },
});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onLoadSettings: () => dispatch(loadSettings()),
    onUpdateSettings: data => dispatch(updateSettings(data)),
    onClearStatusBar: () => dispatch(clearStatusBar()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'EditProfileSettingsForm',
    enableReinitialize: true,
    validate,
  })(UserSettings),
);



/** WEBPACK FOOTER **
 ** ./src/containers/user-settings/index.js
 **/